import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import stockService from "../services/stock-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
const CopyDrugs = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [parentsList, setParentList] = useState([]);
  const [copyType, setCopyType] = useState(1);
  const [facList, setFacList] = useState([]);
  const [sourceFacility, setSourceFacility] = useState("");
  const [targetFacility, setTargetFacility] = useState("");
  const [selectedParent, setSelectedParent] = useState("");
  const { register, setValue } = useForm({});
  const getParents = async () => {
    try {
      setLoading(true);
      let resp = await stockService.getParent();
      if (resp) {
        setParentList(resp);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  async function getFacilities(parentId) {
    if (parentId !== "") {
      try {
        setLoading(true);
        let resp = await stockService.getFacByParent(parentId);
        resp.sort((a, b) => a.name.localeCompare(b.name));
        setFacList(resp);
        setSelectedParent(parentId);
        setLoading(false);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while getting facilities details. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    }
  }
  async function cpyDrugsFromFacility(
    parentId,
    sourceFacility,
    targetFacility
  ) {
    setTargetFacility(targetFacility);
    setTimeout(async function () {
      if (window.confirm("Are you sure to copy drugs ?")) {
        try {
          setLoading(true);
          let params = {
            parent: parentId,
            source: parseInt(sourceFacility),
            target: parseInt(targetFacility),
          };
          let resp = await stockService.cpyfrmFacility(params);
          if (resp) {
            const { hide } = cogoToast.success("Drugs Copied Successfully!", {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            });
          } else {
            const { hide } = cogoToast.error(
              "Error while copying...Please try after sometime.",
              {
                hideAfter: 15,
                onClick: () => {
                  hide();
                },
              }
            );
          }
          setLoading(false);
        } catch (e) {
          const { hide } = cogoToast.error(
            "Error while copying...Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
          setLoading(false);
        }
      }
    }, 1000);
  }
  async function cpyDrugsFromParents(sourceParent, targetParent) {
    if (window.confirm("Are you sure to copy drugs ?")) {
      try {
        setLoading(true);
        let params = {
          source: sourceParent,
          target: targetParent,
        };
        let resp = await stockService.cpyParents(params);
        if (resp) {
          const { hide } = cogoToast.success("Drugs Copied Successfully!", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
        } else {
          const { hide } = cogoToast.error(
            "Error while copying...Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
        setLoading(false);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while copying...Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    }
  }
  useEffect(() => {
    getParents();
  }, []);
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">COPY STOCK FORM</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <span className="w-1/2 inline-block text-sm">
                <input
                  type="radio"
                  className="mr-4 w-4 h-4"
                  name="copyType"
                  value="1"
                  defaultChecked={true}
                  onChange={() => {
                    setCopyType(1);
                    setValue("sourceParent", "");
                    setValue("tParent", "");
                  }}
                />
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                Parent To Parent</label>
              </span>
              <span className="w-1/2 inline-block text-sm">
                <input
                  type="radio"
                  value="2"
                  onChange={() => {
                    setCopyType(2);
                    setValue("sourceParent", "");
                    setValue("tParent", "");
                  }}
                  className="mr-4 w-4 h-4"
                  name="copyType"
                />
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                Facility To Facility</label>
              </span>
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">Source Parent</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="sourceParent"
                aria-label="Select Parent"
                ref={register({
                  required: "You must select Parent",
                })}
                id="sourceParent"
                onChange={(e) => {
                  getFacilities(e.target.value);
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select Parent</option>
                {parentsList
                  ? parentsList.map((parent, i) => {
                      return (
                        <option key={i} value={parent}>
                          {parent}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li
              className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3  ${
                copyType === 1 ? "show" : "hidden"
              }`}
            >
              <label className="text-labelclr font-semibold text-sm tracking-wider">Target Parent</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="tParent"
                aria-label="Select Parent"
                ref={register({
                  required: "You must select Parent",
                })}
                id="tParent"
                onChange={(e) => {
                  cpyDrugsFromParents(selectedParent, e.target.value);
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select Parent</option>
                {parentsList
                  ? parentsList.map((parent, i) => {
                      return (
                        <option key={i} value={parent}>
                          {parent}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li
              className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3 ${
                copyType === 2 ? "show" : "hidden"
              }`}
            >
              <label className="text-labelclr font-semibold text-sm tracking-wider">Source Facility</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="sourcefacility"
                aria-label="Select Facility"
                ref={register({
                  required: false,
                })}
                onChange={(e) => {
                  setSourceFacility(e.target.value);
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Facility</option>
                {facList
                  ? facList.map((facility, i) => {
                      return (
                        <option key={i} value={facility.id}>
                          {facility.name}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li
              className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3 ${
                copyType === 2 ? "show" : "hidden"
              } `}
            >
              <label className="text-labelclr font-semibold text-sm tracking-wider">Target Facility</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="facility"
                aria-label="Select Facility"
                ref={register({
                  required: false,
                })}
                defaultValue={targetFacility}
                onChange={(e) => {
                  setTargetFacility(e.target.value);
                  cpyDrugsFromFacility(
                    selectedParent,
                    sourceFacility,
                    e.target.value
                  );
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Facility</option>
                {facList
                  ? facList.map((facility, i) => {
                      return (
                        <option key={i} value={facility.id}>
                          {facility.name}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CopyDrugs)
);
